var _rect, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTableLastOrderFt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 26,
    height: 26,
    fill: "url(#pattern0)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 39C30.4934 39 39 30.4934 39 20C39 9.50659 30.4934 1 20 1C9.50659 1 1 9.50659 1 20C1 30.4934 9.50659 39 20 39ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#D91F05"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1115_386",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1115_386",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAC70lEQVRoge2YS2sTURiGn28yM7W6ahEXtSZR21hBC0LpooruFcFN6qorpSjoxo2CS0UFF/4BdWEQhC7cuPAKuqiKSy+YqK1trF0UvIDY2lzmc9HE1jiTpGNMR5gHhpyZ78175s05OWcSCAkJCQkJCQnxjVQrvt7UkjCKznFVSYio4b8T/YrKve5s/rKA49fH3duDzEarH4eHQGvDOhNGEhP5wUb5AXh/qkUu0sCbB1Al+TZu7mmkp+nZmdBXHh5RZz/ID9+9GDKsShJAlX7gkW+vCjwDCKwutxPZ4q2/6SQTt3eBAqBirPkbr0p8fzGDgucI/DNUhzIxa2dNnfDZEL3S/b5wt5qs+QFgU+mojoKjkkxH7YM92dyIlyzoU0hE9JxWWe5XYgRSonqtqkK0BYyUQhvQlYmaA2QLo27S5gcQGU9M5u/XkmXixgjKcOlNQ4BrgOBOIUdT5aYhDL7tosVNFtgAiYUpMwag0KZ5e5+bLrABBBSR6+VzxRly0wU2AECkICnKWziyN9PB2kpNoAN0Tc2/U3haOrWxrAOVmkAHWEAeLDals7Ia+AAiFKvVfe8Dr2PmgKgMiUhU0ElBU92ThSfN9vE1Am/i9gUDGRXhCOhehaMO8jgTtc8326euAEufRdJRe1BVT7oKRU+lo3ayHs9G+Xj/Jo5Z74E4gMITge+lUi+wbqGpN0X1qoocAimvEDPA8wq7pU+g46WjXp9FnXBiy0T+Ul0B0jH7rKCnveoA85pv783y5VUn7WbE+lRN2wCfolOUHVunci+WXvScQhErdwa4zK+N5E9WYfYB2NbCq1/q8JlT4VjlzUON/4UAXnXSbpvmdnWwABQ5jHCwVM4pvBTYBtilazdE9Uot33p9HJijtfC8J8M3N5+aASpJb1jdIUbuGch6l9v6qI7d3/NhdrpZPsteRns+zE4bTmSPqNz5vSK3Rc3d9XTaSJ9lj8BS3m1mXdGx4hEjP9E1xsxK+4SEhISEhPx3/AQ4XSawTBW/2QAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableLastOrderFt);
export default __webpack_public_path__ + "static/media/iconTableLastOrderFT.f6d9ace1ca0f6ff1b876c95d50dcc3f4.svg";
export { ForwardRef as ReactComponent };